
const { PRIMITIVE_CONTEXT_TYPES: VALUE_TYPES } = require("./required-context-entity-type");

function payloadContextCandidates(payloadSpec) {
  if (!Array.isArray(payloadSpec)) {
    return [];
  }
  const seen = new Set();
  const candidates = [];
  for (const item of payloadSpec) {
    const alias = typeof item?.name === "string" ? item.name.trim() : "";
    if (!alias || seen.has(alias)) {
      continue;
    }
    seen.add(alias);
    const dataType = item?.binding?.bind?.dataType;
    candidates.push({ alias, valueType: VALUE_TYPES.includes(dataType) ? dataType : "string" });
  }
  return candidates;
}

function mergeContextCandidates(payloadCandidates, declaredCandidates) {
  const payload = Array.isArray(payloadCandidates) ? payloadCandidates : [];
  const declared = Array.isArray(declaredCandidates) ? declaredCandidates : [];
  const payloadAliases = new Set(payload.map(candidate => candidate.alias));
  return [...payload, ...declared.filter(candidate => !payloadAliases.has(candidate.alias))];
}

module.exports = { payloadContextCandidates, mergeContextCandidates };
